import { Component, Input, OnInit, signal } from '@angular/core';
import { Building } from 'app/classes/building';
import { Gateway } from 'app/classes/gateway';
import { License, LicenseBuilding, LicenseGateway } from 'app/classes/license';
import { APIService } from 'app/shared/api.service';
import { BillingBuilding, BillingService } from "../../shared/billing.service";

@Component({
  selector: 'app-billing-buildings-home',
  templateUrl: './billing-buildings-home.component.html',
  styleUrls: ['./billing-buildings-home.component.css'],
  providers: [],
  standalone: false
})
export class BillingBuildingsHomeComponent implements OnInit {

  static readonly STORAGE_KEY = 'app-billing-buildings-home:default';

  @Input()
  building: Building;

  list: BillingBuilding[];
  gateways: Gateway[];
  sort: any = {};
  isReady = signal<boolean>(false);
  license: License;
  dialogOpen = signal<'license'>(null);

  constructor(private billingService: BillingService, private apiService: APIService) {

  }

  ngOnInit(): void {
    this.get();
  }

  get() {
    this.isReady.set(false);
    this.billingService
      .getLicensesForBuilding(this.building.id)
      .then(r => {
        this.building.licenses = r;
        this.billingService
          .getLicensesForBuildingGateways(this.building.id)
          .then(g => {
            this.gateways = g;
            this.isReady.set(true);
          });
      });
  }

  setBuildingLicense(building: Building, license: License) {
    const lBuilding = new LicenseBuilding(license);
    lBuilding.setBuilding(building);

    this.openLicense(lBuilding);
  }

  setGatewayLicense(gateway: Gateway) {
    const licenseGateway = new LicenseGateway(gateway.license);
    licenseGateway.setGateway(gateway);

    this.openLicense(licenseGateway);
  }

  openLicense(license: LicenseBuilding | LicenseGateway) {
    this.license = license;

    this.dialogOpen.set('license');
  }

  licenseUpdated() {
    // this.apiService.toastSuccess('License submitted', '');
    this.get();
    this.dialogOpen.set(null);
  }

}
